import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  Type,
  ViewChild,
  ViewContainerRef,
  Injector,
  HostListener,
  Inject,
} from "@angular/core";
import { ViewRef } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";

import { NgxSpinnerService } from "ngx-spinner";
import {
  BehaviorSubject,
  fromEvent,
  interval,
  Observable,
  Subject,
  Subscription,
  takeUntil,
} from "rxjs";
import { action } from "src/app/interfaces/action";
import { CardView } from "src/app/interfaces/cardview";
import { ChildrenForm } from "src/app/interfaces/children";
import { columnsDef } from "src/app/interfaces/columnsDef";
import { DataGridColumns } from "src/app/interfaces/dagrid-columns";
import { Filter } from "src/app/interfaces/filter";
import { FormConfig } from "src/app/interfaces/formconfig";
import { CryptoServices } from "src/app/services/CryptoServices";
import { DialogService } from "src/app/services/dialog.service";
import { FormServices } from "src/app/services/form.services";
import { HTTPService } from "src/app/services/http.service";
import { PermissionServices } from "src/app/services/permission.services";
import {
  SnackbarService,
  SnackMessage,
} from "src/app/services/snackbar.service";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";
import { UserConfigServices } from "src/app/services/user-config.services";
import { Capitalize } from "src/app/system-utils/pipes/capitalize";
import { ObjectUtil } from "src/app/system-utils/utils/ObjectUtil";
import { StringUtils } from "src/app/system-utils/utils/StringUtils";
import { PromptFilterViewComponent } from "../prompt-filter-view/prompt-filter-view.component";
import { CustomActionParametersComponent } from "./custom-action-parameters/custom-action-parameters.component";
import { GridConfigDialogComponent } from "./grid-config-dialog/grid-config-dialog.component";
import { SimpleFilterViewComponent } from "../simple-filter-view/simple-filter-view.component";
import {
  ColumnMode,
  DatatableComponent,
  SortType,
  TableColumn,
} from "@swimlane/ngx-datatable";

import {
  BodyScrollEndEvent,
  ScrollDirection,
  ColDef,
  ColumnApi,
  ColumnResizedEvent,
  GridApi,
  GridReadyEvent,
  RowClickedEvent,
  RowDoubleClickedEvent,
  ICellRendererParams,
  RowNode,
  ValueFormatterParams,
  SortChangedEvent,
  ColumnState,
  RowClassParams,
  IRowNode,
  RowSelectedEvent,
  HeaderValueGetterParams,
  ITooltipParams,
} from "@ag-grid-community/core";
import { localePt } from "../../../assets/locale.pt.js";
import moment from "moment";
import { HttpErrorResponse } from "@angular/common/http";
import {
  Component as cpm,
  REGISTRY,
} from "src/app/interfaces/registry-services";
import { CurrencyPipe, DecimalPipe } from "@angular/common";
import { DynamicFormsService } from "src/app/services/dynamic-forms.service";
import { FormFieldPropertiesDetailComponent } from "../formview/form-field-properties/form-field-properties-detail/form-field-properties-detail.component";
import { ItensPermission } from "src/app/interfaces/RolePermission";
import { GridColorConfigurationComponent } from "./grid-color-configuration/grid-color-configuration.component";
import { FlowModalComponent } from "../flow-action/flowaction.component";
import { flowData } from "src/app/interfaces/flowData";
import { FormulaServices } from "src/app/services/formula.service";
import { Variable } from "src/app/forms/formula-tester/formula-tester.component";
import { TranslateService } from "@ngx-translate/core";
import { ThemeService } from "src/app/services/theme.service";
import { ExcelUtils } from "src/app/system-utils/utils/ExcelUtils";
import { LanguageServices } from "src/app/services/LanguageServices";
import { GenericLogComponent, LogConfiguration } from "../generic-log/generic-log.component";
import { TemplateDetailComponent } from "src/app/builder-screen-beta/template-detail/template-detail.component";


export interface ExcelProcess {
  line: number;
  status: string;
  message: string;
  total: number;
}

export interface PageInfo {
  offset: number;
  pageSize: number;
  limit: number;
  count: number;
}

export class Page {
  size: number;
  pageNumber: number;
}

export interface MultiTableConfig{
  columnName:string,
  columnDesc:string, 
  colspan:number, 
  format:string,
  dateFromFormat?:string, 
  dateFormat?:string
}

@Component({
    selector: "simple-datagrid",
    templateUrl: "./simple-datagrid.component.html",
    styleUrls: ["./simple-datagrid.component.scss"],
    standalone: false
})
export class SimpleDatagridComponent implements OnInit, OnDestroy {
  
  getStyleGridRows = null;
  sub: Subscription;
  sub2: Subscription;
  sub3: Subscription;
  sub4: Subscription;
  sub5: Subscription;
  sub6: Subscription;
  sub7: Subscription;
  sub8: Subscription;
  sub9: Subscription;
  sub10: Subscription;
  sub11: Subscription;
  sub12: Subscription;
  sub13: Subscription;
  sub14: Subscription;
  sub20: Subscription;
  sub21: Subscription;
  canExport = false;
  canConfig = false;
  currentSortColumn:string;
  gridColor:string;
  gridActivated=true;
  logConfiguration:LogConfiguration = null;
  
  readonly headerHeight = 40;
  readonly rowHeight = 40;
  readonly pageLimit = 500;
  SortType = SortType;
  ColumnMode = ColumnMode;
  

  @ViewChild("editContainer", { read: ViewContainerRef })editContainer: ViewContainerRef;
  /** controla a abertura do dropdown do filtro (nz-select) */
  filterPanelOpen = false;
  compareFilter = (a: Filter, b: Filter): boolean => a && b && a.name === b.name;

  /** spinner NG-ZORRO da área do grid (substitui o ngx-spinner nomeado) */
  gridLoading = false;
  gridLoadingTip: string = null;

  private showGridSpinner(tip: string = null): void {
    this.gridLoadingTip = tip;
    this.gridLoading = true;
  }

  private hideGridSpinner(): void {
    this.gridLoading = false;
    this.gridLoadingTip = null;
  }
  @ViewChild("staticRef", { static: true }) staticRef: TemplateRef<any>;
  @ViewChild("fks", { static: true }) fks: TemplateRef<any>;
  @ViewChild("regularCol", { static: true }) regularCol: TemplateRef<any>;
  @ViewChild("headerTemplateFilter", { static: true })
  headerTemplateFilter: TemplateRef<any>;
  @ViewChild("headerTemplateNonFilter", { static: true })
  headerTemplateNonFilter: TemplateRef<any>;
  @ViewChild("input", { static: true }) input;
  @ViewChild("dynamicTable") dynamicTable: DatatableComponent;
  //input variables
  customComponents:object[] = [];
  @Input() disableEditCustomComponent: boolean =  false;
  @Input('componentedit') componentedit: Type<any>;
  /** Quando preenchido, o modo inclusão usa o template (ex.: ID 12 para Amazon) em vez do componentedit. */
  @Input() templateIdForAdd: number | null = null;
  isTemplateMode = false;
  @Input() entityName: string;
  @Input() beforeRemove: Function;
  @Input() beforeAdd: Function;
  @Input() beforeUpdate: Function;
  @Input() getCondition: Function;
  @Input() condition: string;
  @Input() parentRow: CardView;
  @Input() selectedRow: Function;
  @Input() parentCondition: string;
  @Input() events: Observable<void>;
  @Input() nodata: boolean = false;
  @Input() compact: boolean = false;
  @Input() child: ChildrenForm;
  @Input() customAction: action[] = [];
  @Input() forceParentRow: string;
  @Input('fakeinsert') isFakeInsert = true;
  @Input()customFields:DataGridColumns[] = [];
  @Input() customFunction: Function;
  @Input() callbackFunction:Function;
  @Input() showImageData:boolean = true;
  @Input() showImageDataBase64:boolean = false;
  hasLog:boolean = false;
  actionList: action[] = [];
  showGetFrom: boolean = false;
  changed: boolean = false;
  showGetFromComplex: boolean = false;
  QueryGetFrom:string = null;
  QueryGetFromParam:string = null;
  complexQueryGetFrom:string = null;
  complexQueryGetFromParam:string = null;
  selectedRows:{index:number,data:Object}[] = [];
  // variables

  $$REFERENCES: ChildrenForm[];
  autoRefresh = false;
  refreshInterval = 20000;
  row: Object;
  editing: Subject<Boolean> = new Subject<Boolean>();
  formGroup: UntypedFormGroup;
  rows: Object[] = [];
  columns: DataGridColumns[] = [];
  //displayedColumns:TableColumn[] = [];
  displayedColumns: ColDef[] = [];
  showAction = false;
  formConfig: FormConfig[] = [];
  showIcon: boolean = true;
  preference: object;
  tableInformation: columnsDef[];
  formViewColumns = 3;
  userConfig: object;
  availableColumns: string[] = [];
  evento: string;
  readonly alterando: string = "editando";
  readonly inserindo: string = "inserindo";
  readonly acao: string = "acao";
  componentEditArray = [];
  canEdit: boolean;
  canDelete: boolean;
  canInsert: boolean;
  filterSelect = new UntypedFormControl();
  filter: Filter[] = [];
  fatherCondition: string;
  totalLines: number = -1;
  pageNumber: number = 0;
  cache: any = {};
  eventsSubscription: Subscription;
  loading: boolean = false;
  editingRow: object;
  logExcelImport: Subject<ExcelProcess> = new Subject();
  log: string = "";
  lastFilter: Object;

  showLimitLinesError = false;
  disableSearch = true;
  contextmenuColumn: string;
  filtroStr = `Nenhum campo selecionada para filtro.`;
  //private gridColumnApi!: ColumnApi;
  private gridApi!: GridApi;
  selectedColumn = [];
  selected: any[] = [];
  showPaginator = false;
  showPagination = true;
  cancelPaginator = false;
  flowData: flowData;


  public columnTypes: {
    [key: string]: ColDef;
  } = {
    numberColumn: { width: 130, filter: "agNumberColumnFilter" },
    nonEditableColumn: { editable: false },
    dateColumn: {
      // specify we want to use the date filter
      filter: "agDateColumnFilter",
      // add extra parameters for the date filter
      filterParams: {
        // provide comparator function
        comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
          // In the example application, dates are stored as dd/mm/yyyy
          // We create a Date object for comparison against the filter date
          const dateParts = cellValue.split("/");
          const day = Number(dateParts[0]);
          const month = Number(dateParts[1]) - 1;
          const year = Number(dateParts[2]);
          const cellDate = new Date(year, month, day);
          // Now that both parameters are Date objects, we can compare
          if (cellDate < filterLocalDateAtMidnight) {
            return -1;
          } else if (cellDate > filterLocalDateAtMidnight) {
            return 1;
          } else {
            return 0;
          }
        },
      },
    },
  };
  editingRowIndex: number = -1;
  rowLength: number = 0;
  filtrando: boolean = false;
  selectedNodes: IRowNode[] = [];
  permission: ItensPermission;
  dataMultiTableConfig: MultiTableConfig = null;
  dataGridFocus: boolean = false;
  
  constructor(
    private translate: TranslateService,
    private fb: UntypedFormBuilder,
    private snackBar: SnackbarService,
    public breakpointObserver: BreakpointObserver,
    private dialogServices: DialogService,
    private routerParam: ActivatedRoute,
    private ucs: UserConfigServices,
    private uas: UserAuthenticationServices,
    private http: HTTPService,
    private cd: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private fs: FormServices,
    private ap: PermissionServices,
    private spinner: NgxSpinnerService,
    private capitalize: Capitalize,
    private crypto: CryptoServices,
    private el: ElementRef,
    public dynaServices: DynamicFormsService,
    private injector: Injector,
    public ThemeService:ThemeService,
    public ls:LanguageServices,
    private formulaService: FormulaServices
  ) {
    this.editing.next(false);

    this.sub = this.editing.subscribe((keepOpen) => {
      
      if (!keepOpen) {
        this.isTemplateMode = false;
      }

      if (!keepOpen && ObjectUtil.isNotEmpty(this.componentedit)) {
        this.removeComponentEdit();
      }
      
      if ( !keepOpen && !this.changed){
        this.cancelPaginator = false;
      }else{
        if ( !keepOpen && this.changed){
          this.cancelPaginator = false;
          this.showGridSpinner();
          this.apply(false).then(()=>{
            this.hideGridSpinner();  
          });
        }else{
          this.hideGridSpinner();
          this.cancelPaginator = false;
        }
      }

      if (keepOpen) {
        this.autoRefresh = false;
      }
      return keepOpen;
    });

    this.sub2 = this.logExcelImport.subscribe((value: ExcelProcess) => {
      let log: string = "";

      if (value.status == "sucesso") {
        log = `Linha ${value.line} processada com sucesso.\n`;
        let s: SnackMessage = {
          message: log,
          tipo: value.status,
          action: "OK",
        };
        this.snackBar.addMessage(s);
      } else {
        log = `Linha ${value.line} processada com erros. ( ${value.message} )\n`;
        let s: SnackMessage = {
          message: log,
          tipo: value.status,
          action: "OK",
        };
        this.snackBar.addMessage(s);
      }
      //});
      //}
    });
  }

  removeComponentEdit() {
    const component = this.componentEditArray.find(
      (c) =>
        (this.componentedit != null && c.instance instanceof this.componentedit) ||
        c.instance instanceof TemplateDetailComponent
    );
    const componentIndex = this.componentEditArray.indexOf(component);

    if (componentIndex !== -1) {
      this.editContainer.remove(componentIndex);
      this.componentEditArray.splice(componentIndex, 1);
    }
  }

  @HostListener('focusout', ['$event'])
  focusout(event) {
    setTimeout(() => {
      this.dataGridFocus = false;
    });
  }
  

  @HostListener('document:keydown',['$event'])
  onKeyPress($event: KeyboardEvent) {
    if ( this.dataGridFocus ){
      if(($event.ctrlKey || $event.metaKey) && $event.keyCode == 67){
        let copyValue = ExcelUtils.toExcelFormat(this.selectedRows);
        
        if ( copyValue != null ){
            if (window.isSecureContext && navigator.clipboard) {
              navigator.clipboard.writeText(copyValue);
            } else {
              ExcelUtils.unsecuredCopyToClipboard(copyValue);
            }
            this.snackBar.showInformation("Linhas copiadas para o clipboard.");
        }
      }
    }
      
  }
  
  
  selectedData(event:RowSelectedEvent){
      let index = this.selectedRows.findIndex(d=>d.index == event.rowIndex);
      if ( index > -1 ){
          this.selectedRows.splice(index,1);
      }else{
          this.selectedRows.push({index:event.rowIndex, data:event.data});
      }

      if ( this.selectedRows.length == 0){
        this.dataGridFocus = false;
      }else{
        this.dataGridFocus = true;
      }
  }

  openLog(){
    if ( this.selected.length == 0 || this.selected.length > 1){
        this.snackBar.showError(
            "Para consultar o log deve-se selecionar apenas uma linha."
        );
        return;
    }
    
    if ( this.hasLog && this.logConfiguration!= null && this.selected.length == 1 ){
      
      this.logConfiguration.codecompany = this.selected[0].CODECOMPANY;
      this.logConfiguration.codeproduct = this.selected[0].CODEPRODUCT;

      this.dialogServices.openGenericDialog(
        GenericLogComponent,
        this.logConfiguration,
        (data) => {
        },
        ()=>{},
        "80vh",
        "80vw",
        false,
        null,
        "S",
        "30px"
      );
    }
    
  }

  data(event: ClipboardEvent) {
    
    let displayedColumnTables: string[] = [];
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData("text");
    let row_data = StringUtils.safeSplit(pastedText, "\n", "[", "]");
    let displayedColumns = row_data[0].split("\t");
    delete row_data[0];
    // Create table dataSource

    let data: { entityName: string; ob: object }[] = [];
    let mensagem = "";

    displayedColumns.forEach((columns) => {
      if (columns.split(".").length > 0) {
        let entityName = columns.split(".")[0];
        if (displayedColumnTables.indexOf(entityName) == -1) {
          displayedColumnTables.push(entityName);
        }
      }
    });

    let nroLine = 0;
    row_data.forEach((x) => {
      //let line = x.split('\t');
      let line = StringUtils.safeSplit(x, "\t", "[", "]");
      if (line.length == displayedColumns.length) {
        nroLine++;
        let col = 0;
        let ob = {};

        if (displayedColumnTables.length > 0) {
          label1: displayedColumnTables.forEach((entityName) => {
            col = 0;
            ob = {};

            if (displayedColumns[col] != null) {
              line.forEach((l) => {
                let columnName = displayedColumns[col].toUpperCase();

                let first = 0;
                if (
                  columnName
                    .toUpperCase()
                    .startsWith(entityName.toUpperCase() + ".")
                ) {
                  if (first == 0) {
                    if (line[col].toUpperCase() == "{@DATANULL}") {
                      return;
                    }
                  } else {
                    first++;
                  }

                  ob[
                    displayedColumns[col]
                      .toUpperCase()
                      .replace("\r", "")
                      .replace("\t", "")
                      .replace(entityName.toUpperCase() + ".", "")
                  ] =
                    line[col] != null
                      ? line[col].replace("\r", "").replace("\t", "")
                      : null;
                }
                col++;
              });
            }

            let mainData: { entityName: string; ob: object } = {
              entityName: this.capitalize.transform(entityName),
              ob,
            };

            let index = data.findIndex(
              (main: { entityName: string; ob: object }) => {
                return (
                  main.entityName.toUpperCase() === entityName.toUpperCase() &&
                  JSON.stringify(main.ob) === JSON.stringify(ob)
                );
              }
            );
            if (Object.keys(ob).length > 0 && index == -1) {
              data.push(mainData);
            }
          });
        } else {
          line.forEach((l) => {
            ob[
              displayedColumns[col]
                .toUpperCase()
                .replace("\r", "")
                .replace("\t", "")
            ] =
              line[col] != null
                ? line[col].replace("\r", "").replace("\t", "")
                : null;
            col++;
          });
          let mainData: { entityName: string; ob: object } = {
            entityName: this.capitalize.transform(this.entityName),
            ob,
          };
          data.push(mainData);
        }
      }
    });

    if (data.length <= 0) {
      this.snackBar.showError("Não existem linhas para processar.");
      return;
    }
    this.dialogServices.errorDialoag = false;
    this.dialogServices.openNewDialog(
      `Serão importadas ${data.length} linhas. Deseja continuar?`,
      async () => {
        let i = 1;
        let logExcel: ExcelProcess[] = [];
        let response: Map<string, object> = new Map();
        for (const d of data) {
          let ex: ExcelProcess = {
            line: i,
            status: "Aguardando",
            message: "",
            total: 0,
          };
          let dataSend: object = d.ob;
          dataSend["entityName"] = this.capitalize.transform(d.entityName);

          Object.keys(dataSend).forEach((ds) => {
            try {
              let value: string = dataSend[ds];
              let reg: RegExpMatchArray = value.match(/{@(.*?)}/g);

              if (reg != null) {
                value = value.replace("{@", "").replace("}", "");

                let entityName = value.split(".")[0];
                let columnName = value.split(".")[1];
                if (response.has(entityName)) {
                  let dataObject = response.get(entityName);
                  dataSend[ds] = dataObject[columnName];
                }
              }
            } catch (exception) {
              throw exception;
            }
          });

          if (response.has(d.entityName)) {
            response.delete(d.entityName);
          }

          await new Promise((resolve, reject) => {
            this.sub3 = this.http
              .post(dataSend, "JsonBrokerServices/save", false, true, true)
              .subscribe(
                (x) => {
                  response.set(d.entityName.toUpperCase(), x);

                  ex.message = "Processada com sucesso.";
                  ex.status = "sucesso";
                  ex.total = data.length;
                  logExcel.push(ex);
                  this.logExcelImport.next(ex);
                  resolve(true);
                },
                (error) => {
                  try {
                    ex.message = error.error.message; //JSON.parse(this.crypto.decrypt(error.error.value)).message;
                    ex.status = "erro";
                    ex.total = data.length;
                    logExcel.push(ex);
                    this.logExcelImport.next(ex);
                  } catch (Exception) {
                    ex.message = Exception; //"Erro não mapeado. Tentar importar novamente."
                    ex.status = "erro";
                    ex.total = data.length;
                    logExcel.push(ex);
                    this.logExcelImport.next(ex);
                  }

                  resolve(true);
                },
                () => {
                  resolve(true);
                }
              );
          });

          i++;
        }
      }
    );
  }

  savingForm(evento:{changing:boolean, keepOpen:boolean} ) {  
    
    this.changed = evento.changing;
    this.editing.next(evento.keepOpen);
    
    let ob: Object = {};
    this.tableInformation
      .filter((x) => {
        return x.ISPK === 1;
      })
      .forEach((y) => {
        if (
          this.formGroup != null &&
          this.formGroup.get(y.COLUMNNAME) != null
        ) {
          ob['this.'+y.COLUMNNAME] = this.formGroup.get(y.COLUMNNAME).value; //jdbc
          //ob[y.COLUMNNAME] = this.formGroup.get(y.COLUMNNAME).value;
        }
      });
  }

  ngAfterViewInit(): void {
    this.loadInsertComponent().then((data) => {
      if (this.customAction.length > 0) {
        this.customAction.forEach((data) => {
          this.actionList.push(data);
        });
      }
      this.loadCustomComponent();

      this.loadMultiTable();

      //

      if (this.actionList.length > 0) {
        this.showAction = !this.showAction;
      }
    });
  }


  async loadHistoryTable() {
    return await new Promise((resolve, reject) => {
      let local = {
        entityName: "Mktppref",
        showImageData: false,
        showImagaDataBase64: false,
        showPresentation: false,
        showRelationshipData: false,
        showRelationship: false,
        condition: `name='tempai.genericlog.component.${this.entityName.toLowerCase()}'`,
      };

      this.http
        .post(local, "JsonBrokerServices/find", false, true, true).subscribe({
          next:(result) => {
            if (ObjectUtil.isNotEmpty(result["Mktppref"])) {
              if (ObjectUtil.isNotEmpty(result["Mktppref"])) {
                if ((result["Mktppref"] as Object[]).length > 0) {
                  let config: string = result["Mktppref"][0]["TEXT"];
                    resolve(config);
                }
              }
            }
          },
          error:(error) => {
            throw error;
          }
        }
      );
    });
  }

  async loadInsertComponent() {
    return await new Promise((resolve, reject) => {
      let local = {
        entityName: "Mktppref",
        showImageData: false,
        showImagaDataBase64: false,
        showPresentation: false,
        showRelationshipData: false,
        showRelationship: false,
        condition: `name='mktp.view.insert.component.${this.entityName.toLowerCase()}'`,
      };

      this.http
        .post(local, "JsonBrokerServices/find", false, true, true)
        .subscribe(
          (result) => {
            if ( this.disableEditCustomComponent ){
              resolve(true)
            }else{
              if (ObjectUtil.isNotEmpty(result["Mktppref"])) {
                if (ObjectUtil.isNotEmpty(result["Mktppref"])) {
                  if ((result["Mktppref"] as Object[]).length > 0) {
                    let component: string = result["Mktppref"][0]["TEXT"];
                    this.componentedit = REGISTRY.get(component);
                  }
                }
              }
              resolve(true);
            }
            
          },
          (error) => {
            throw error;
          }
        );
    });
  }

  async loadCustomComponent() {
    return await new Promise((resolve, reject) => {
      let local = {
        entityName: "Mktppref",
        showImageData: false,
        showImagaDataBase64: false,
        showPresentation: false,
        showRelationshipData: false,
        showRelationship: false,
        condition: `name='mktp.view.custom.component.${this.entityName.toLowerCase()}'`,
      };

      this.http
        .post(local, "JsonBrokerServices/find", false, true, true)
        .subscribe(
          (result) => {
            
            if (ObjectUtil.isNotEmpty(result["Mktppref"])) {
              if (ObjectUtil.isNotEmpty(result["Mktppref"])) {
                if ((result["Mktppref"] as Object[]).length > 0) {
                  let components:object[] = JSON.parse(result["Mktppref"][0]["TEXT"]);
                  for ( var comp of components ){
                      this.customComponents.push( comp);
                  }
                }
              }
            }
            resolve(true);
          },
          (error) => {
            throw error;
          }
        );
    });
  }

  saveUserConfig() {
    let jsonDec: Object = {
      entityName: "Mktpdic",
      condition: `instancename='${this.entityName}'`,
    };
    
    let userConfig = {
      formViewColumns: this.formViewColumns,
      config: this.formConfig,
      configgrid: this.columns,
      gridcolor: this.gridColor
    };

    Object.keys(this.userConfig).forEach(key=>{
        if ( key != 'formViewColumns' && key !='config' && key !='configgrid' && key !='gridcolor'){
          userConfig[key] = this.userConfig[key];
        }
    })

    this.ucs
      .saveUserCfg(jsonDec, this.uas.user.iduser, this.filter, userConfig)
      .then(
        (me) => {},
        (error) => {
          throw error;
        }
      );
  }

  getAllData() {
    this.loading = true;
    this.showGridSpinner();

    this.sub4 = this.ucs
      .loadUserConfig(this.uas.user.iduser, this.entityName)
      .subscribe((response) => {
        this.userConfig = {};
        if (ObjectUtil.isNotEmpty(response["Mktpusercfg"])) {
          if (ObjectUtil.isNotEmpty(response["Mktpusercfg"][0])) {
            if (ObjectUtil.isNotEmpty(response["Mktpusercfg"][0]["FILTER"])) {
              this.filter = JSON.parse(response["Mktpusercfg"][0]["FILTER"]);
            }

            if (ObjectUtil.isNotEmpty(response["Mktpusercfg"][0]["CONFIG"])) {
              if (ObjectUtil.isNotEmpty(response["Mktpusercfg"][0]["CONFIG"])) {
                this.userConfig = JSON.parse(
                  response["Mktpusercfg"][0]["CONFIG"]
                );

                if (
                  Object.keys(this.userConfig).findIndex(
                    (ind) => ind == "formviewcolumns"
                  ) > -1
                ) {
                  this.formViewColumns = this.userConfig["formviewcolumns"];
                }

                if (
                  Object.keys(this.userConfig).findIndex(
                    (ind) => ind == "gridcolor"
                  ) > -1
                ) {
                  this.gridColor = this.userConfig["gridcolor"];
                  this.applyGridColors();
                }

                if (
                  Object.keys(this.userConfig).findIndex(
                    (ind) => ind == "pagesize"
                  ) > -1
                ) {
                  //this.pagesize = this.userConfig['pagesize'];
                }

                if ( this.userConfig['nodata']){
                  this.nodata = this.userConfig['nodata'];
                }

                if (
                  Object.keys(this.userConfig).findIndex(
                    (ind) => ind == "config"
                  ) > -1
                ) {
                  this.formConfig = this.userConfig["config"];
                }

                if (
                  Object.keys(this.userConfig).findIndex(
                    (ind) => ind == "configgrid"
                  ) > -1
                ) {
                  this.columns = this.userConfig["configgrid"];
                }
              }
            }
          }
        }
        
        this.sub6 = this.ucs
          .loadActions(this.entityName)
          .subscribe((responseAction) => {
            this.actionList = responseAction["Mktpdicaction"];

            this.actionList = this.actionList.filter((data) =>
              this.ap.checkActionPermission(data.IDACTION)
            );

            if (this.actionList.length > 0) {
              this.showAction = !this.showAction;
            }
            this.loading = false;
            this.cd.detectChanges();
          });

        this.sub20 = this.ucs
          .loadGetFromAction(this.entityName, this.uas.user)
          .subscribe((responseAction) => {
            let data: Object[] = responseAction["Mktpcontractpref"];
            if (data != null && data.length > 0) {
              for ( var line of data ){
                if ( line['NAME'].toString().toUpperCase()=="GET"+this.entityName.toUpperCase()+"_PARAM"){
                  this.QueryGetFromParam = line['TEXT'] == null ? null : line['TEXT'].toString();
                }

                if ( line['NAME'].toString().toUpperCase()=="GET"+this.entityName.toUpperCase()){
                  this.QueryGetFrom = line['TEXT'] == null ? null : line['TEXT'].toString();
                }
                
              }
              this.showGetFrom = true;
            } else {
              this.showGetFrom = false;
            }

            this.loading = false;
            this.cd.detectChanges();
          });

          this.sub21 = this.ucs
          .loadGetFromActionComplex(this.entityName, this.uas.user)
          .subscribe((responseAction) => {
            let data: Object[] = responseAction["Mktpcontractpref"];
            if (data != null && data.length > 0) {
              for ( var line of data ){
                if ( line['NAME'].toString().toUpperCase()=="GET"+this.entityName.toUpperCase()+"_COMPLEX_PARAM"){
                  this.complexQueryGetFromParam = line['TEXT'] == null? null : line['TEXT'].toString();
                }

                if ( line['NAME'].toString().toUpperCase()=="GET"+this.entityName.toUpperCase()+"_COMPLEX"){
                  this.complexQueryGetFrom =  line['TEXT'] == null? null : line['TEXT'].toString();
                }
                
                
              }
              
              this.showGetFromComplex = true;
            } else {
              this.showGetFromComplex = false;
            }

            this.loading = false;
            this.cd.detectChanges();
          });
        if (!this.nodata) {
          this.apply(false,0);
        } else {
          //this.refreshData(-1);
          this.apply(false,-1);
        }
      });
  }

  ngOnDestroy(): void {

    this.cancelPaginator = true;

    if (this.sub != null) {
      this.sub.unsubscribe();
    }
    if (this.sub2 != null) {
      this.sub2.unsubscribe();
    }
    if (this.sub3 != null) {
      this.sub3.unsubscribe();
    }
    if (this.sub4 != null) {
      this.sub4.unsubscribe();
    }
    if (this.sub5 != null) {
      this.sub5.unsubscribe();
    }
    if (this.sub6 != null) {
      this.sub6.unsubscribe();
    }
    if (this.sub7 != null) {
      this.sub7.unsubscribe();
    }
    if (this.sub8 != null) {
      this.sub8.unsubscribe();
    }
    if (this.sub9 != null) {
      this.sub9.unsubscribe();
    }
    if (this.sub10 != null) {
      this.sub10.unsubscribe();
    }
    if (this.sub11 != null) {
      this.sub11.unsubscribe();
    }
    if (this.sub12 != null) {
      this.sub12.unsubscribe();
    }
    if (this.sub13 != null) {
      this.sub13.unsubscribe();
    }
    if (this.sub14 != null) {
      this.sub14.unsubscribe();
    }
    if (this.sub20 != null) {
      this.sub20.unsubscribe();
    }
    if (this.sub21 != null) {
      this.sub21.unsubscribe();
    }

    

    this.cd.detach();
  }

  async apply(byAutoRefesh: boolean = false, nroLinhas:number = 0) {
    this.evento = null;
    
    this.selected = [];
    this.selectedNodes = [];
    this.editingRowIndex = -1

    if(this.selectedRow){
      this.selectedRow(this.selected);
    }

    this.totalLines = -1;
    this.rowLength = 0;
    this.showGridSpinner();
    
    if ( nroLinhas == -1 ){
      this.rowLength = nroLinhas;
      this.cancelPaginator = false;
    }
    
    if (ObjectUtil.isNotEmpty(this.parentRow)) {
      let obFather = {};
      if (ObjectUtil.isNotEmpty(this.child)) {
        this.child.columns.forEach((y) => {
          obFather['this.'+y.column] = this.parentRow.linha[y.columnRef]; //jdbc
          //obFather[y.column] = this.parentRow.linha[y.columnRef];
        });
      }
      

      if (Object.keys(obFather).length > 0) {
        this.fatherCondition = ObjectUtil.transformConditionToString(obFather);
      }
    }

    if (ObjectUtil.isNotEmpty(this.fatherCondition)) {
      this.condition =
        this.fatherCondition + " AND " + this.transformcondition();
    } else {
      this.condition = this.transformcondition();
    }
    
    this.filtrando = true;
    if (this.condition != null) {
      if (
        this.condition.indexOf("{") > -1 &&
        this.condition.indexOf("}") > -1
      ) {
        if (byAutoRefesh) {
          this.snackBar.showError(
            "Não é permitido ativar a atualização automática com parâmetros variável."
          );
          this.autoRefresh = false;
          this.hideGridSpinner();
          return;
        }
        this.dialogServices.openGenericDialog(
          PromptFilterViewComponent,
          { data: this.condition, lastFilter: this.lastFilter },
          async (data) => {
            this.condition = JSON.parse(data).expressao;
            this.lastFilter = JSON.parse(data).group;
            //this.refreshData(0, byAutoRefesh);
            while ( ( this.totalLines > this.rowLength || this.totalLines == -1 ) && this.cancelPaginator == false){
              this.showPaginator = true;
              await this.refreshData(this.rowLength, byAutoRefesh, false);
            }
            
            if ( this.cancelPaginator ){
              this.hideGridSpinner();
            }
            this.cancelPaginator = false;
            this.showPaginator = false;
            
          },
          () => {
            this.hideGridSpinner();
          }
        );
      } else {
        
        while ( ( this.totalLines > this.rowLength || this.totalLines == -1 ) && this.cancelPaginator == false){
          this.showPaginator = true;
          await this.refreshData(this.rowLength, byAutoRefesh, false);
        }
        
        if ( this.cancelPaginator ){
          this.hideGridSpinner();
        }
        this.cancelPaginator = false;
        this.showPaginator = false;
      }
    } else {
      while ( ( this.totalLines > this.rowLength || this.totalLines == -1) && this.cancelPaginator == false){
        this.showPaginator = true;
        await this.refreshData(this.rowLength, byAutoRefesh, false);
      } 
      
      if ( this.cancelPaginator ){
        this.hideGridSpinner();
      }
      this.cancelPaginator = false;
      this.showPaginator = false;
    }
  }

  updateCondition(newCondition){
    this.condition =newCondition; 
    this.cd.detectChanges();
  }

  openFilter() {
    let data = {
      filters: this.filter,
      columns: this.tableInformation,
    };

    this.dialogServices.openGenericDialog(
      SimpleFilterViewComponent,
      data,
      (data) => {
        this.saveUserConfig();
      },
      () => {
        this.saveUserConfig();
      }
    );
  }

  getTypeValidation(column, type,tableInformation) {
    let infoColumn = tableInformation.find(
      (data) => data.COLUMNNAME == column.columnName
    );
    
    if ( infoColumn==null ){
        return false;
    }
    
    let validationError = infoColumn.VALIDATIONERROR;
    let icon = infoColumn.GRIDICON;
    
    if (validationError != null && type == "select") {
      let ob: object = JSON.parse(validationError);
      if ( ob['type'] == type ){
        return true;
      }
      return false;
    }

    if (icon != null && type == "icon") {
      let ob: object = JSON.parse(icon);
      if ( ob['type'] == type ){
        return true;
      }
      return false;
    }

    if (validationError != null && type == "action") {
      let ob: object = JSON.parse(validationError);
      if ( ob['type'] == type ){
        return true;
      }
      return false;
    }
  }

  validationData(column, data: string, type: string) {
    let columnName = column.columnName;
    if (type == "select") {
      let validationError = this.tableInformation.find(
        (data) => data.COLUMNNAME == columnName
      ).VALIDATIONERROR;

      let ob: object = JSON.parse(validationError);

      if (ob != null) {
        if (ob["type"] == "select") {
          let options: object[] = ob["options"];

          let dataValue = options.find((val) => val["value"] == data);
          
          if (dataValue != null) {
            return data + " - " + dataValue["view"];
          } else {
            return data;
          }
        }
      }
    }

    if (type == "icon") {
      let gridIcon = this.tableInformation.find(
        (data) => data.COLUMNNAME == columnName
      ).GRIDICON;

      let ob: object = JSON.parse(gridIcon);

      if (ob != null) {
        if (ob["type"] == "icon") {
          let formula: string = ob["formula"];

          if (formula != null) {
            formula = formula.replace("data", "data=" + data);
            let evaluation = eval("(" + formula + ")()");
            return evaluation;
          } else {
            return data;
          }
        }
      }
    }
  }

  transformcondition(): string {
    let condition: string = "";

    const selectedFilters: Filter[] = (this.filterSelect.value as Filter[]) || [];

    if (selectedFilters.length > 0) {
      let i: number = 0;
      selectedFilters.forEach((value) => {
        if (i == 0) {
          condition = condition + " " + value.expression;
        } else {
          condition = condition + " AND " + value.expression;
        }
        i++;
      });
    } else {
      condition = " 0=0 ";
    }

    return condition;
  }

  
  async refreshData(
    currentPage: number,
    byAutoRefesh: boolean = false,
    showSpinner: boolean = true
  ) {
    return await new Promise((resolve, reject) => {
      this.loading = true;
      this.showLimitLinesError = false;
      if (byAutoRefesh) {
        //currentPage = this.paginator.pageIndex * this.paginator.pageSize;
      }
      let currentTotalLine = this.rowLength;

      let limit = 100;
      if ( currentTotalLine <= 500 ){
        limit = 100;
      }else if ( currentTotalLine > 500 && currentTotalLine<= 5000 ){
          limit = 500;
      }else if ( currentTotalLine >5000 ) {
          limit = 5000;
      }

      let ob = {
        entityName: this.entityName,
        showPresentation: true,
        showRelationshipData: false,
        showRelationship: true,
        fetchSize: currentPage,
        showImageData: this.showImageData,
        showImageDataBase64: this.showImageDataBase64,
        //rows: this.pageLimit,
        rows: limit
      };

      if (currentPage == -1) {
        ob["condition"] = "0=1";
      } else {
        if (ObjectUtil.isNotEmpty(this.condition)) {
          ob["condition"] = this.condition;
        }

        if(this.getCondition != null){
          ob["condition"] = this.getCondition();
        }
      }

      //if (currentPage > 9500) {
        ///this.showLimitLinesError = true;
        //return;
      //}
      
      let index = -1;

      if (this.evento == this.alterando || this.evento == this.acao) {
        index = this.editingRowIndex;
      }

      if (!byAutoRefesh && showSpinner) {
        this.showGridSpinner();
      }

      if (this.filtrando) {
        if ( this.gridApi!= null ){
          this.gridApi.setRowData([]);
        }
        this.filtrando = false;
      }

      this.sub5 = this.http.post(ob, "JsonBrokerServices/find", true).subscribe(
        (x) => {
          let tableInformation: columnsDef[] = x["table_information"];
          this.totalLines = x["totalLines"];
          let $$REFERENCES: ChildrenForm[] = x["$$REFERENCES"];
          let dataRows: any[] = x[this.entityName];
          
          if (this.callbackFunction != null) {
            this.callbackFunction.call(this,dataRows);
          }
          
          if (
            currentPage == 0 &&
            this.evento != this.alterando &&
            this.evento != this.inserindo &&
            this.evento != this.acao
          ) {
            if (this.gridApi != null) {
              this.gridApi.applyTransaction({ add: dataRows });
            }
          } else {
            if (
              this.evento == this.alterando ||
              this.evento == this.inserindo
            ) {
              var rowNode = this.gridApi.getDisplayedRowAtIndex(index);
              if (rowNode != null) {
                rowNode.setData(dataRows[0]);
              }
            } else {
              if (this.gridApi != null) {
                this.gridApi.applyTransaction({ add: dataRows });
              }
            }
          }

          if (this.gridApi != null) {
            this.rowLength = this.gridApi.getDisplayedRowCount();
          }

          this.addCustomFields(tableInformation);
          this.addcolumns(tableInformation);
          

          this.loading = false;
          this.hideGridSpinner();
          setTimeout(() => {
            if (
              this.cd !== null &&
              this.cd !== undefined &&
              !(this.cd as ViewRef).destroyed
            ) {
              this.cd.detectChanges();
            }
          }, 250);


          if (this.userConfig &&
            this.userConfig["config"] != null &&
            this.userConfig["config"].length > 0
          ) {
            this.formConfig = this.userConfig["config"];
            this.formConfig.forEach((config: FormConfig) => {
              let col: columnsDef = tableInformation.find(
                (column) => column.COLUMNNAME === config.name
              );
              if (col != null) {
                col.cols = config.colspan == undefined ? 1 : config.colspan;
                col.rows = config.rowspan == undefined ? 1 : config.rowspan;
                col.x = config.x;
                col.y = config.y;
                col.visible =
                config.visible == undefined ? true : config.visible;
                col.tab = config.tab == undefined ? "Geral" : config.tab;
              }
            });
          }

          this.tableInformation = tableInformation;
          this.$$REFERENCES = $$REFERENCES;
          this.loading = false;
          resolve(dataRows[0]);
        },
        (error) => {
          this.hideGridSpinner();
          throw error;
        },
        ()=>{
          this.hideGridSpinner();
        }
      );
    });
  }
  addCustomFields(tableInformation:columnsDef[]) {
    
    if ( tableInformation.length > 0 ){
      this.customFields.forEach(data=>{
        
        if ( tableInformation.findIndex(d=>d.COLUMNNAME==data.columnName)==-1){
          let config:columnsDef={
            COLUMNNAME: data.columnName,
            COLUMNDESC: data.columnDesc,
            DATATYPE: data.type,
            VALIDATIONERROR: data.validationError,
            VISIBLE: 1,
            ISIDENTITY: 0,
            IDCOLUMN: Math.max(...tableInformation.map(d=>d.IDCOLUMN))+1,
            CELL:0,
            LINE:0,
            ISREQUIRED:0,
            PLACEHOLDER: data.columnDesc,
            visible: true,
            tab: data.tab== null ? "Disponivel": data.tab
          }
          tableInformation.push(config);
        }
          
      });
    }
  }

  cancelLoading(){
      this.sub5.unsubscribe();
      this.http.stopSubscription();
      this.showPaginator = false;
      this.cancelPaginator=true;
  }

  executeCustomAction(
    action: action,
    parameters: string,
    retry: boolean = false
  ) {

    this.showGridSpinner(action.IDCONF ? "Executando configuração "+action.IDCONF : null);
    
    this.sub7 = this.http
      .executeBackEndAction(
        this.entityName,
        action,
        this.selected,
        parameters,
        retry
      )
      .subscribe(
        (sucesso) => {
          let mensagens: string[] = sucesso["mensagens"];

          let mensagemFinal: string = "";
          if (ObjectUtil.isNotEmpty(mensagens)) {
            mensagens.forEach((mensagem) => {
              mensagemFinal = mensagemFinal + mensagem + "\n\r";
            });

            this.snackBar.showSuccess(mensagemFinal);
          } else {
            this.snackBar.showSuccess("Ação executada com sucesso.");
          }

          let selection = this.selectedNodes;
          this.selected = [];

          const promises = [];
          selection.forEach((selected) => {
            this.editingRowIndex = selected.rowIndex;
            promises.push(
              new Promise((resolve, reject) => {
                let ob: Object = {};
                this.tableInformation
                  .filter((x) => {
                    return x.ISPK === 1;
                  })
                  .forEach((y) => {
                    ob['this.'+y.COLUMNNAME] = selected.data[y.COLUMNNAME]; //jdbc
                    //ob[y.COLUMNNAME] = selected.data[y.COLUMNNAME];
                  });

                this.condition = ObjectUtil.transformConditionToString(ob);
                //this.row = selected;
                //this.refreshData(0);
                this.cancelPaginator = false;
                this.apply(false,0);
                resolve("salvando");
              })
            );
          });

          Promise.all(promises);
        },
        (exception) => {
          this.hideGridSpinner();
          if (exception instanceof HttpErrorResponse) {
            if (
              ObjectUtil.isNotEmpty(exception.error) &&
              ObjectUtil.isNotEmpty(exception.error.message)
            ) {
              if (
                (exception.error.message as String).indexOf(
                  "__CHOOSE__N__S__"
                ) > -1
              ) {
                let title = exception.error.message.split("__")[2];
                this.dialogServices.openNewDialog(
                  title,
                  (data) => {
                    this.executeCustomAction(action, parameters, true);
                  },
                  (data) => {
                    this.snackBar.showInformation(
                      "Processo cancelado pelo usuário."
                    );
                  }
                );
              } else {
                throw exception;
              }
            } else {
              throw exception;
            }
          } else {
            throw exception;
          }
        }
      );
  }

  callCustomAction(action: action, event: Event) {
    if (this.selected.length > 0) {
      this.evento = this.acao;
      this.loading = true;
      
      if (action.TYPE === "P" || action.TYPE === "J" || action.TYPE === "F") {
        if (action.PARAMETERS != null && action.PARAMETERS.length > 0) {
          this.dialogServices.openGenericDialog(
            CustomActionParametersComponent,
            action.PARAMETERS,
            (data) => {
              this.executeCustomAction(action, data);
            }
          );
        } else {
          this.executeCustomAction(action, null);
        }
      } else {
        if (action.TYPE == "A") {
          let serviceName = action.EXPRESSION.split(".")[0];
          let methodName = action.EXPRESSION.split(".")[1];
          let parameter = action.PARAMETERS;
          const component = REGISTRY.get(serviceName);
          const service = this.injector.get<any>(component);
          const method = service[methodName];
          const paramCount = method.length;

          if ( parameter != null && parameter.length > 0) {
            if (paramCount == 2 ){
              service[methodName](this.selected,parameter);
            }else if ( paramCount ==3 ) {
              service[methodName](this.selected,parameter, this);
            }else if ( paramCount ==1 ){
              service[methodName](this.selected);
            }else{
              service[methodName]();
            }
          }else{
            if (paramCount == 1 ){
              service[methodName](this.selected);
            }else if ( paramCount ==2 ) {
              service[methodName](this.selected, this);
            }else{
              service[methodName]();
            }
          }

        }else if(action.TYPE == "C"){

          if (action.PARAMETERS != null && action.PARAMETERS.length > 0) {
            this.dialogServices.openGenericDialog(
              CustomActionParametersComponent,
              action.PARAMETERS,
              (data) => {
                //this.executeCustomAction(action, data);
                openFlowData(data, this.selected, this);
              }
           );
          }else{
            openFlowData(null,  this.selected, this);

          }

        
        } else if (action.TYPE === 'FN') {
          // Formula nova (motorNovo=true): EXPRESSION e a formula, selected e passado como variaveis
          const vars: Variable[] = [
            { key: '__rows', value: JSON.stringify(this.selected), type: 'TEXTO' }
          ];
          if (this.selected.length > 0) {
            Object.keys(this.selected[0]).forEach(k => {
              vars.push({ key: k, value: String(this.selected[0][k] ?? ''), type: 'TEXTO' });
            });
          }
          this.spinner.show('formula-nova');
          this.formulaService.executeFormula(action.EXPRESSION, vars, true)
            .then((resultado) => {
              this.snackBar.showSuccess(`Resultado: ${resultado}`);
            })
            .catch((err: any) => {
              this.snackBar.showError('Erro na formula: ' + (err?.message ?? err));
            })
            .finally(() => {
              this.spinner.hide('formula-nova');
              this.loading = false;
            });
        } else if (action.TYPE === 'NM') {
          // Fluxo NEWMODE (FlowServices/runOnlineAsync) - mesmo modal do TYPE=C, detecta internamente
          if (action.PARAMETERS != null && action.PARAMETERS.length > 0) {
            this.dialogServices.openGenericDialog(
              CustomActionParametersComponent,
              action.PARAMETERS,
              (data) => { openFlowData(data, this.selected, this); }
            );
          } else {
            openFlowData(null, this.selected, this);
          }
        }
      }
    } else {
      this.snackBar.showError(
        "Nenhuma linha selecionada para excutar ação."
      );
      
    }

    function openFlowData(parameters, selected, self) {
      let flowData: flowData = {
        selected: selected,
        action: action,
        function: null,
        parameters: parameters
      };



      self.dialogServices.openGenericDialog(
        FlowModalComponent,
        flowData,
        (data) => {
        },
        ()=>{},
        "80vh",
        "80vw",
        true,
        null,
        "S",
        "30px"
      );
    }
  }

  convertValue(value): boolean {
    if (value == "true") {
      return true;
    } else {
      return false;
    }
  }

  addcolumns(tableInformation: columnsDef[]) {
    
    this.displayedColumns = [];
    
    if (this.columns.length > 0) {
      this.columns.sort((a: DataGridColumns, b: DataGridColumns) => {
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;
        return 0;
      });
    }

    //if (this.columns.length != tableInformation.length) { 
      tableInformation.forEach((x) => {
        let index = this.columns.findIndex(
          (col) => col.columnName == x.COLUMNNAME
        );

        //if ( x.LANGUAGE != null ){
          //this.addTranslations(x.LANGUAGE, x.COLUMNNAME);
        //}

        if (index > -1) {
          
          //this.columns[index].columnDesc = x.LANGUAGE != null ? this.entityName.toUpperCase()+'.'+x.COLUMNNAME.toUpperCase() : x.COLUMNDESC;
          this.columns[index].columnDesc =  this.entityName.toUpperCase()+'.'+x.COLUMNNAME.toUpperCase();
          this.columns[index].validationError = x.VALIDATIONERROR;
          this.columns[index].gridIcon = x.GRIDICON;
          //this.columns[index].header = x.LANGUAGE != null ? this.entityName.toUpperCase()+'.'+x.COLUMNNAME.toUpperCase() : x.COLUMNDESC;
          this.columns[index].header = this.entityName.toUpperCase()+'.'+x.COLUMNNAME.toUpperCase();
          this.columns[index].type = x.DATATYPE;
          //this.columns[index].sort = null;
        }

        if (index == -1) {
          let column: DataGridColumns = {
            //columnDesc: x.LANGUAGE != null ? this.entityName.toUpperCase()+'.'+x.COLUMNNAME.toUpperCase() : x.COLUMNDESC,
            columnDesc:  this.entityName.toUpperCase()+'.'+x.COLUMNNAME.toUpperCase(),
            columnName: x.COLUMNNAME,
            order: -1,
            width: 80,
            type: x.DATATYPE,
            visible: false,
            validationError: x.VALIDATIONERROR,
            gridIcon: x.GRIDICON,
            //header:  x.LANGUAGE != null ? this.entityName.toUpperCase()+'.'+x.COLUMNNAME.toUpperCase() : x.COLUMNDESC,
            header:  this.entityName.toUpperCase()+'.'+x.COLUMNNAME.toUpperCase(),
            sort: null,
            custom: false
          };

          this.columns.push(column);
        }
        //}
      });
    //}

    if ( this.customFields ){
        this.customFields.forEach(x=>{
            let idxCol = this.columns.findIndex(d=>d.columnName == x.columnName);
            if ( idxCol== -1){
              let column: DataGridColumns = {
                columnDesc: x.columnDesc,
                columnName: x.columnName,
                order: -1,
                width: 80,
                type: x.type,
                visible: false,
                validationError: x.validationError,
                gridIcon: x.gridIcon,
                header: x.header,
                sort: null,
                custom: true
              };

              this.columns.push(column);
            }else{
                this.columns[idxCol].validationError = x.validationError;
                this.columns[idxCol].columnDesc = x.columnDesc;
                this.columns[idxCol].columnName = x.columnName;
                this.columns[idxCol].gridIcon = x.gridIcon;
                this.columns[idxCol].type = x.type;
                this.columns[idxCol].custom = true;
            }
        })
    }

    var todelete:number[] = [];
    this.columns.filter(d=>d.custom).forEach(custom=>{
        let index = this.customFields.findIndex(d=>d.columnName==custom.columnName);
        if ( index == -1 ){
            todelete.push(index);
        }
    });
    if ( todelete.length > 0 ){
      todelete.forEach(i=>{
        this.columns.splice(i,1);
      });
    }
    

    this.columns.forEach((dataColumn) => {
      if (dataColumn.visible) {
        let column: ColDef = {
          field: dataColumn.columnName,
          width:
            dataColumn.width == null || dataColumn.width == 0
              ? 80
              : dataColumn.width,
          /*headerName:
            dataColumn.columnDesc == null
              ? dataColumn.columnName
              : dataColumn.columnDesc,*/
          headerValueGetter: (col:HeaderValueGetterParams)=>{
            if (dataColumn.columnDesc!=null && dataColumn.columnDesc.indexOf('.')==-1){
              col.colDef.headerTooltip = dataColumn.columnDesc;
              return dataColumn.columnDesc;
            }else{
              col.colDef.headerTooltip = this.ls.instant(this.entityName.toUpperCase()+"."+dataColumn.columnName.toUpperCase());
              return this.ls.instant(this.entityName.toUpperCase()+"."+dataColumn.columnName.toUpperCase())
            }
            
          },
          sortable: true,
          filter: true,
          resizable: true,
          maxWidth: 600,
          colId: dataColumn.columnName,
          sort: dataColumn.sort == null?  null : dataColumn.sort == 'asc' ? 'asc' : 'desc'
        };

        if (dataColumn.type == "DATETIME" || dataColumn.type == "DATE") {
          //column.type = 'dateColumn';
          //column.headerTooltip = dataColumn.columnDesc;
          column.valueFormatter = (data: ValueFormatterParams) => {
            if (
              data.value === "null" ||
              data.value === null ||
              data.value === ""
            ) {
              return "";
            }
            return moment(data.value).format("DD/MM/yyyy HH:mm:ss.SSS");
          };
        }

        if (dataColumn.type == "FLOAT") {
          //column.headerTooltip = dataColumn.columnDesc;
          column.type = "numericColumn";
          column.valueFormatter = (data: ValueFormatterParams) => {
            if (
              data.value === "null" ||
              data.value === null ||
              data.value === ""
            ) {
              return "";
            }

            let currencyPipe: DecimalPipe = new DecimalPipe("pt-BR");
            return currencyPipe.transform(data.value);
          };
        }

        let tableLocal = tableInformation.find(
          (y) => y.COLUMNNAME == dataColumn.columnName
        );

        if (tableLocal != null) {
          if (tableLocal.ISPK == 1) {
            //column.headerTooltip = dataColumn.columnDesc;
            column.cellRenderer = function (params: ICellRendererParams) {
              if (params.value !== undefined) {
                return params.value;
              } else {
                // linha ainda carregando (scroll infinito): spinner local, sem gif externo
                return '<span class="tem-cell-loading"></span>';
              }
            };
          }
        }

        //if ( dataColumn.type == "DATETIME"){
        //column['pipe']= new DateOnlyPipe("pt")
        //column.template = this.headerTemplateNonFilter;
        //  column['headerTemplate'] = this.headerTemplateNonFilter;
        //}else{
        //column['headerTemplate'] = this.headerTemplateFilter;
        //}

        var scope = this;
        if ( dataColumn.sort !=null){
          this.currentSortColumn = dataColumn.columnName;
        }
        
        this.gridApi.applyColumnState({
          state: [
              {
                  colId: dataColumn.columnName,
                  sort: dataColumn.sort == null?  null : dataColumn.sort == 'asc' ? 'asc' : 'desc'
              }
          ],
          defaultState: {
              // important to say 'null' as undefined means 'do nothing'
              sort: null
          }
        });
     

        if (dataColumn.columnName.indexOf("->") > -1) {
          ///column.headerTooltip = dataColumn.columnDesc;
          column.tooltipValueGetter
          column.cellRenderer = params=> {
            if (
              params.value === "null" ||
              params.value === null ||
              params.value === ""
            ) {
              return "";
            }
            return `<span class="texto" matTooltip="${params.value}" [ngStyle]="{'width':${column.width}" >${params.value}</span>`;
            
          };
        } else {
          if (
            tableLocal != null &&
            (tableLocal.VALIDATIONERROR != null || tableLocal.GRIDICON != null)
          ) {
            this.applyValidatationError(scope,dataColumn,column, tableInformation);
          } else {
            if (dataColumn.type != "DATETIME" && dataColumn.type != "FLOAT") {
              //column.headerTooltip = dataColumn.columnDesc;
              column.cellRendererParams = function (params: ICellRendererParams) {
                if (
                  params.value === "null" ||
                  params.value === null ||
                  params.value === ""
                ) {
                  return "";
                }
                
                return `<span class="texto" matTooltip="${params.formatValue}" [ngStyle]="{'width':${column.width}" >${params.value}</span>`;
              };
            }
          }
        }
        
        if (  dataColumn.validationError!=null && dataColumn.custom){
          this.applyValidatationError(scope,dataColumn,column, tableInformation);
        }

        this.displayedColumns.push(column);
      }
    });
  }
  
  addTranslations(language: string, columnName:string) {
       let languageList:Object[] = JSON.parse(language);
       for ( var lang of languageList){
         let ob = { 
            [this.entityName.toUpperCase()+'.'+columnName.toUpperCase()]: lang['text']
         }
         this.translate.setTranslation(lang['language'], 
         ob,true);
        }
      // }
      // this.translate.setTranslation('pt-BR',{
      //     "MKTPDIC.APRESENTATIONFIELD":"Apresentação"
      // },true);
      // this.translate.setTranslation('en-US',{
      //     "MKTPDIC.APRESENTATIONFIELD":"Apresentation"
      // },true);
      
  }

  applyValidatationError(scope, dataColumn:DataGridColumns, column:ColDef, tableInformation){
    //column.headerTooltip = dataColumn.columnDesc;
    column.cellRenderer = function (params: ICellRendererParams) {
      
      if (
        params.value === "null" ||
        params.value === null ||
        params.value ===   ""
      ) {
        return "";
      }
      if (scope.getTypeValidation(dataColumn, "icon", tableInformation)) {
        return `<i  class="${scope.validationData(
          dataColumn,
          params.value,
          "icon"
        )}"></i><span class="span10"></span>`;
      }
      if (scope.getTypeValidation(dataColumn, "select", tableInformation)) {
        return `<span>${scope.validationData(
          dataColumn,
          params.value,
          "select"
        )}</span>`;
      }
      
      if (scope.getTypeValidation(dataColumn, "action", tableInformation)) {
          return params.value;
      }
    };
  }

  sortChanged(param:SortChangedEvent){
    let sortedColumns = param.columnApi.getColumnState().find(col => Boolean(col.sort));
    
    if (sortedColumns!=null ){
      this.columns.forEach(col=>{
        if (  col.columnName ==  sortedColumns.colId ){
            col.sort = sortedColumns.sort;
        }else{
          col.sort = null;
        }
    });

    }else {
        if ( this.currentSortColumn != null ){
          this.columns.forEach(col=>{
            if (  col.columnName ==  this.currentSortColumn){
                col.sort = null;
            }
          }); 

          this.currentSortColumn = null;
        }
    }
    
    this.saveUserConfig();
  }

  expandFields() {
    const allColumnIds: string[] = [];
    this.gridApi.getColumns()!.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    this.gridApi.autoSizeAllColumns();
  }

  
  openGridColorConfig(){
    
    let data = {
      gridColor: this.gridColor,
    };

    this.dialogServices.openGenericDialog(
      GridColorConfigurationComponent,
      data,
      (data) => {
        this.gridColor = data;
        this.applyGridColors();
        this.cd.detectChanges();

        this.saveUserConfig();
      },
      null,
      "80vh",
      "80vh"
    );

  }

  onGridReady(event: GridReadyEvent) {
    //this.gridColumnApi = event.columnApi;
    this.gridApi = event.api;
    this.getAllData();
    this.applyGridColors();
    
  }

    applyGridColors(){
    if ( this.gridColor != null ){
      let fn = new Function("params",this.gridColor) as (params:RowClassParams)=>{};
      if ( fn!= null ){
        try{
          this.gridApi.setGridOption('getRowStyle',fn);
        }catch(Exception){
          console.log(Exception);
        }
        
      }
      
    }
  }

  getAgGridTranslations(){
      let translations =  {};
      let keys:string[] = Object.keys(this.translate.translations[this.translate.currentLang]).filter(d=>d.toLowerCase().startsWith('aggrid'));
      for ( var key of keys ){
          let keyName = key.substring(7)
          Object.assign(translations,{[keyName]:this.translate.translations[this.translate.currentLang][key]});
      }
      
      return translations;
  }


  ngOnInit(): void {
    //this.localeText = this.getAgGridTranslations();
    this.permission = this.ap.checkPermission(this.entityName);

    this.canInsert = this.permission.canInsert;
    this.canEdit = this.permission.canEdit;
    this.canDelete = this.permission.canDelete;
    this.canExport = this.permission.canExport;
    this.canConfig = this.permission.canConfig;
    this.fatherCondition = this.condition;
    this.loadHistoryTable().then((data:string)=>{
        if ( data  ){
          this.hasLog = true;
          this.logConfiguration = JSON.parse(data) as LogConfiguration;
        }
    });

    this.translate.onLangChange.subscribe(() => {
      
      if (this.gridApi!=null){
        this.gridApi.refreshHeader();
        this.gridActivated = false;
        //this.localeText = this.getAgGridTranslations();
        setTimeout(()=>{
          this.gridActivated = true;
        })

      }
      
    });
    
    this.translate.onDefaultLangChange.subscribe(() => {
      if (this.gridApi!=null){
        this.gridApi.refreshHeader();
        this.gridActivated = false;
        //this.localeText = this.getAgGridTranslations();
        setTimeout(()=>{
          this.gridActivated = true;
        })
      }
    });

    // this.sub11 = this.breakpointObserver
    //   .observe(["(min-width: 1470px)"])
    //   .subscribe((state: BreakpointState) => {
    //     if (this.compact) {
    //       this.showIcon = true;
    //     } else {
    //       if (state.matches) {
    //         this.showIcon = false;
    //       } else {
    //         this.showIcon = true;
    //       }
    //     }

    //     this.cd.detectChanges();
    //   });

    this.sub10 = interval(this.refreshInterval).subscribe(async (t) => {
      await new Promise((resolve, reject) => {
        this.execAutoRefesh();
        resolve(true);
      });
    });

  }

  execAutoRefesh() {
    if (this.autoRefresh) {
      this.apply(true);
    }
  }

  adicionarLine($event) {
    this.changed = false;
    this.editing.next(true);
    this.formGroup = this.fb.group({});
    this.row = {};
    this.evento = this.inserindo;

    const context = {
      evento: this.evento,
      row: {},
      formGroup: this.formGroup,
      parentRow: this.parentRow,
      actionList: this.actionList,
      forceParentRow: this.forceParentRow,
      $$REFERENCES: this.$$REFERENCES,
      formViewColumns: this.formViewColumns,
      entityName: this.entityName,
      filter: this.filter,
      userConfig: this.userConfig,
      tableInformation: this.tableInformation,
      canConfig: this.canConfig,
      customComponents: this.customComponents,
      dataMultiTableConfig: this.dataMultiTableConfig
    };

    if (this.templateIdForAdd != null) {
      this.isTemplateMode = true;
      setTimeout(() => {
        const componentFactory =
          this.componentFactoryResolver.resolveComponentFactory(
            TemplateDetailComponent
          );
        const component = this.editContainer.createComponent(componentFactory);
        component.instance.templateId = this.templateIdForAdd;
        component.instance.context = context;
        this.sub12 = component.instance.saving.subscribe((evento: { changing: boolean; keepOpen: boolean }) => {
          this.savingForm(evento);
        });
        this.componentEditArray.push(component);
        this.cd.markForCheck();
      }, 1000);
    } else if (this.componentedit != null) {
      this.isTemplateMode = false;
      setTimeout(() => {
        const componentFactory =
          this.componentFactoryResolver.resolveComponentFactory(
            this.componentedit
          );
        const component = this.editContainer.createComponent(componentFactory);
        component.instance.data = context;
        this.sub12 = component.instance.saving.subscribe((evento:{changing:boolean, keepOpen:boolean}) => {
          this.savingForm(evento);
        });
        this.componentEditArray.push(component);
        this.cd.markForCheck();
      }, 1000);
    }
  }

  openGridDialogConfig() {
    let data = {
      columns: this.columns,
    };

    setTimeout(()=>{
        this.dialogServices.openGenericDialog(
          GridConfigDialogComponent,
          data,
          (data) => {
            this.columns = data["columns"];

            this.addcolumns(this.tableInformation);

            this.cd.detectChanges();

            this.saveUserConfig();
          },
          null,
          "80vh",
          "80vh"
        );
    });
    
  }

  removeLine($event) {
    this.changed = false;
    let cnt = this.selectedNodes.length;

    if (cnt == 0) {
      this.snackBar.showError("Nenhuma linha selecionada.");
      return;
    }

    try {
      this.dialogServices.title = "Exclusão de Dados";
      this.dialogServices.openNewDialog(
        "Excluir os itens selecionados?",
        () => {
          this.selectedNodes.forEach((rowNode: RowNode) => {
            let x = rowNode.data;

            if (this.beforeRemove != null) {
              this.beforeRemove.call(this, x);
            }

            let ob: Object = {};
            this.tableInformation
              .filter((x) => {
                return x.ISPK === 1;
              })
              .forEach((y) => {
                ob[y.COLUMNNAME] = x[y.COLUMNNAME];
              });

            let remove: Object = {};
            let condition: string = ObjectUtil.transformConditionToString(ob);
            remove["entityName"] = this.entityName;
            remove["condition"] = condition;

            this.sub13 = this.http
              .post(remove, "JsonBrokerServices/remove", false)
              .subscribe(
                (x) => {
                  this.snackBar.showSuccess("Registro excluido com sucesso");
                  this.gridApi.applyTransaction({ remove: [rowNode.data] });
                },
                (error) => {
                  throw error;
                }
              );
          });
        },
        () => {}
      );
    } catch (Exception) {
      throw Exception;
    }
  }

  editRow(row: object, rowIndex: number) {
    this.changed = false;
    if (!this.canEdit) {
      this.snackBar.showError("Não é permitido editar o registro.");
      return;
    }
    
    this.evento = this.alterando;
    this.isTemplateMode = false;
    this.editing.next(true);
    this.row = row;
    this.editingRow = row;
    this.editingRowIndex = rowIndex;

    this.formGroup = this.fb.group({});
    if (this.componentedit != null) {
      setTimeout(() => {
        const componentFactory =
          this.componentFactoryResolver.resolveComponentFactory(
            this.componentedit
          );
        const component = this.editContainer.createComponent(componentFactory);
        component.instance.data = {
          evento: this.evento,
          row: row,
          formGroup: this.formGroup,
          parentRow: this.parentRow,
          actionList: this.actionList,
          forceParentRow: this.forceParentRow,
          $$REFERENCES: this.$$REFERENCES,
          formViewColumns: this.formViewColumns,
          entityName: this.entityName,
          filter: this.filter,
          userConfig: this.userConfig,
          tableInformation: this.tableInformation,
          canConfig: this.canConfig,
          customComponents: this.customComponents,
          dataMultiTableConfig: this.dataMultiTableConfig
        };
        
        const sub:Subscription = component.instance.saving.subscribe(data=>{
          if (data) {
            this.savingForm(data);
          }else{
            this.savingForm(data);
          }
        });
        
        component.onDestroy(() => {
          sub.unsubscribe();
        });

        this.componentEditArray.push(component);
        this.cd.markForCheck();
      }, 500);
    }
  }

  isColumFilterSelected(column) {
    return this.selectedColumn.indexOf(column.name) > -1 ? true : false;
  }

  selectFilterColumn(column, event: PointerEvent) {
    if (event.pointerType == "mouse") {
      let index = this.selectedColumn.indexOf(column.name);
      if (index > -1) {
        this.selectedColumn.splice(index, 1);
        this.filtroStr = `Nenhum campo selecionada para filtro.`;
        this.disableSearch = true;
        this.input.nativeElement.value = null;
        this.condition = this.fatherCondition;
      } else {
        this.selectedColumn = [];
        this.selectedColumn.push(column.name);

        this.disableSearch = false;
        this.contextmenuColumn = column.name;
        this.filtroStr = `Campo ${this.contextmenuColumn} selecionado para filtro.`;
      }
    }
  }

  ngAfterViewChecked() {
    //this.resizeColumns();
  }

  editLine(event: Event) {
    this.changed = false;
    if (this.selected.length == 1) {
      this.editRow(this.selected[0], this.editingRowIndex);
    } else {
      this.snackBar.showError("Para editar, deve-se selecionar uma linha.");
    }
  }

  eventGridSelect(event: RowClickedEvent) {
    this.selected = event.api.getSelectedRows();
    this.selectedNodes = event.api.getSelectedNodes();
    this.editingRowIndex = event.rowIndex;

    if(this.selectedRow){
      this.selectedRow(this.selected);
    }
    
  }

  eventGrid(event: RowDoubleClickedEvent) {
    this.editRow(event.data, event.rowIndex);
    this.cancelPaginator = true;
    this.cd.markForCheck();
  }

  public onReoder(column: TableColumn, newValue: any, prevValue: any): void {
    this.columns.forEach((data) => {
      if (newValue < prevValue) {
        if (data.order > prevValue) {
          data.order = data.order + 1;
        }
      } else {
        if (data.order > prevValue) {
          data.order = data.order - 1;
        }
      }
    });
    this.columns.find((co) => co.columnName == column.prop).order = newValue;

    this.addcolumns(this.tableInformation);

    this.saveUserConfig();
  }

  public onResize(event: ColumnResizedEvent): void {
    try {
      if (event.finished) {
        if (event.column == null) {
          event.columns.forEach((col) => {
            this.columns.find(
              (co) => co.columnName == col.getColDef().field
            ).width = col.getActualWidth();
          });
          this.addcolumns(this.tableInformation);
          this.saveUserConfig();
        } else {
          this.columns.find(
            (co) => co.columnName == event.column.getColDef().field
          ).width = event.column.getActualWidth();
          this.saveUserConfig();
        }
      }
    } catch (Exception) {
      throw Exception;
    }
  }

  async onScroll(event: BodyScrollEndEvent) {
    if (event.direction == "vertical") {
      if (
        //event.api.getLastDisplayedRow() + 1 ==
        event.api.getLastDisplayedRowIndex()+ 1 == 
          this.gridApi.getDisplayedRowCount() &&
        this.totalLines != this.rowLength
      ) {
        //this.rowLength =
        this.evento = null;
        await this.refreshData(this.gridApi.getDisplayedRowCount());
      }
    }
  }

  editFilter(event: Event, item: Filter) {
    event.stopPropagation();
    event.preventDefault();

    let data = {
      filters: this.filter,
      columns: this.tableInformation,
      editing: item,
    };

    this.dialogServices.openGenericDialog(
      SimpleFilterViewComponent,
      data,
      (data) => {
        this.saveUserConfig();
        this.filterPanelOpen = false;
      },
      () => {
        //this.saveUserConfig();
      }
    );
  }

  removeFilter(event: Event, item: Filter) {
    event.stopPropagation();
    event.preventDefault();

    this.dialogServices.openNewDialog(
      "Deseja realmente excluir o filtro?",
      (data) => {
        this.excluirFiltro(item);
        this.filterPanelOpen = false;
      }
    );
  }

  excluirFiltro(data: Filter) {
    let index = this.filter.findIndex((c) => c.name == data.name);
    this.filter.splice(index, 1);
    this.saveUserConfig();
  }

  getFrom(event,complex:boolean) {
    if ( complex ){
      this.dynaServices
      .getFromPrompt(this.parentRow== null? null : this.parentRow.linha, this.entityName+"_complex", complex, this.complexQueryGetFrom, this.complexQueryGetFromParam, this.selected[0])
      .then((d) => {
        this.apply(false,0);
      })
      .catch((reason) => {
        throw reason;
      });
    }else{
      this.dynaServices
      .getFromPrompt(this.parentRow== null? null : this.parentRow.linha, this.entityName, complex, this.QueryGetFrom, this.QueryGetFromParam, this.selected[0])
      .then((d) => {
        this.apply(false,0);
      })
      .catch((reason) => {
        throw reason;
      });
    }
    
  }

  exportExcel() {
    this.gridApi.exportDataAsCsv({columnSeparator:";"});
  }

  openConfig(event){
    this.dialogServices.openGenericDialog(FormFieldPropertiesDetailComponent,{data:null, entityDesc:null, entityName:this.entityName, steps:[3,4]},(value)=>{

    },()=>{},null,"90vw",true,null,"S","30px");
  }


  loadMultiTable(){
    return new Promise((resolve,reject)=>{
      let codecontract =  this.uas.getContracts();
      let ob = {
        "entityName":"Mktpcontractpref",
        "sql":`SELECT  TOP 1 CONVERT(VARCHAR(100),B.CODECOMPANY)+' - ' +B.NAME COMPANY,A.CODECOMPANY,A.INTERNALID,A.NAME,A.TEXT, A.CODECONTRACT
              FROM MKTPCONTRACTPREF A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
              WHERE A.CODECONTRACT IN (${codecontract})
              AND A.NAME= 'mktp.usa.multitable.${this.entityName}'
              ORDER BY 1`
      }

      this.http.post(ob, 'JsonBrokerServices/findnative', false, true, true).subscribe({
        next: (data) => {
          if (data['SQL']) {
            if ((data['SQL'] as Object[]).length > 0) {
              this.dataMultiTableConfig = JSON.parse(data['SQL'][0]['TEXT']);
            }
          }
          resolve(true);
        },
        error: (error) => {
          throw error;
        }
      });
    });      
  }

}
